/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_Duplicate_NameInputs */



/**
* | output |
* | --- |
* | "You already have a passkey with that name." |
*
* @param {Partner_Security_Passkey_Duplicate_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_duplicate_name = /** @type {((inputs?: Partner_Security_Passkey_Duplicate_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_Duplicate_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben bereits einen Passkey mit diesem Namen.")
	return /** @type {LocalizedString} */ ("You already have a passkey with that name.")
});